import { render, staticRenderFns } from "./Wasaga.vue?vue&type=template&id=6fceab6a&scoped=true&"
import script from "./Wasaga.vue?vue&type=script&lang=js&"
export * from "./Wasaga.vue?vue&type=script&lang=js&"
import style0 from "./Wasaga.vue?vue&type=style&index=0&id=6fceab6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fceab6a",
  null
  
)

export default component.exports